import { useEffect, useState } from "react"
import { env } from "@/utils/env"

// 전역 Promise를 사용하여 스크립트 로딩을 한 번만 실행하도록 보장합니다.
let naverMapPromise: Promise<void> | null = null

export const useNaverMap = () => {
  const [isLoaded, setIsLoaded] = useState(!!window.naver?.maps)

  useEffect(() => {
    if (isLoaded) {
      return
    }

    let isMounted = true

    if (!naverMapPromise) {
      naverMapPromise = new Promise<void>((resolve, reject) => {
        const SCRIPT_ID = "naverMapScript"

        const waitForMapReady = (callback: () => void) => {
          const checkInterval = setInterval(() => {
            if (window.naver?.maps) {
              clearInterval(checkInterval)
              callback()
            }
          }, 100)
        }

        // 스크립트가 이미 있는지 다시 한 번 확인 (다른 인스턴스에 의해 추가되었을 수 있음)
        if (document.getElementById(SCRIPT_ID)) {
          waitForMapReady(resolve)
          return
        }

        const script = document.createElement("script")
        script.id = SCRIPT_ID
        script.type = "text/javascript"
        script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${env.naverMapClientId}&submodules=geocoder`
        script.async = true
        script.onload = () => {
          console.log("Naver Map script loaded, waiting for map object...")
          waitForMapReady(resolve)
        }
        script.onerror = error => {
          console.error("Failed to load Naver Map API", error)
          naverMapPromise = null // 실패 시 다시 시도할 수 있도록 초기화
          reject(error)
        }
        document.head.appendChild(script)
      })
    }

    naverMapPromise
      .then(() => {
        if (isMounted) {
          console.log("Naver Map API completely loaded")
          setIsLoaded(true)
        }
      })
      .catch(() => {
        // 에러는 이미 onerror에서 로깅됨
      })

    return () => {
      isMounted = false
    }
  }, [isLoaded])

  return { isLoaded }
}
